import store from '@/store'
import axios from 'axios'
import router from '@/router/'

export default {
  namespaced: true,
  state: {
    archivo: []
  },
  mutations: {
    set_accion_archivo (state, archivo) {
      state.archivo = archivo
    }
  },
  actions: {
    async setTransportes ({ commit, dispatch, state }, transportes) {
      try {
        const response = await axios({
          method: 'post',
          url: `${store.state.host}/api/vps/files/cargarTransportes`,
          headers: {
            Authorization: 'Bearer ' + store.state.token
          },
          data: transportes
        })
        if (response.status === 200) { // response - object, eg { status: 200, message: 'OK' }
          console.log('success stuff api setTransportes')
          console.log(response.data)
          commit('set_accion_archivo', response.data)
          return true
        } else {
          console.log('por else setTransportes')
        }
        return false
      } catch (err) {
        console.error(err)
        console.log('por catch setTransportes')
        router.push({ path: '/' })
        return false
      }
    }
  },
  getters: {
  }
}
